<sm-title-bar [headerCustomTemplate]="addButton" pageTitle="{{ 'expenses.title' | translate }}" [backWithParams]="true">
  <ng-template #addButton>
    <div class="create_btn_sd">
      <button mat-icon-button aria-label="option menu" [matMenuTriggerFor]="menu" color="accent">
      <mat-icon class="material-icons-round try" [inline]="true">add</mat-icon></button>
    </div>
    <mat-menu #menu="matMenu">
      <button  mat-menu-item (click)="openPurchases()" >
        <mat-icon class="material-icons-outlined">local_mall</mat-icon>
        <span>{{ 'expenses.op1_item_purchase' | translate }}</span>

      </button>
      <button  mat-menu-item (click)="openEmloyees()" >
        <mat-icon class="material-icons-outlined">payments</mat-icon>
        <span>{{ 'expenses.op2_salary_credit' | translate }}</span>
      </button>
      <button  mat-menu-item (click)="onOtherExpenses()">
        <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
        <span>{{ 'expenses.op3_other_business_expense' | translate }}</span>
      </button>
    </mat-menu>
  </ng-template>
</sm-title-bar>

<!-- <p style="    padding-left: 60px;
position: relative;
top: -10px;
">{{ 'expenses.subtitle1' | translate }}: {{monthExpense.toFixed(2)}}  |  {{ 'expenses.subtitle2' | translate }}: {{dailyExpense.toFixed(2)}}
</p> -->



<div class="bradcamp_inventory" *ngIf="!loader">
  <div class="row">
    <div class="over_sectionkl">
      <div class="overall_count_s">
      <p>This month</p>
      <h3>{{overview?.currencySymbol ? overview?.currencySymbol : ''}}{{monthExpense.toFixed(2)}}</h3>
      </div>
      <div class="overall_count_s" style="border-right: none !important;">
        <p>Today</p>
        <h3>{{overview?.currencySymbol ? overview?.currencySymbol : ''}}{{dailyExpense.toFixed(2)}}</h3>
        </div>
    </div>
  
  </div>
  </div>



<!-- <mat-card appearance="outlined" >
  <sm-title-bar></sm-title-bar>
  <div class="rounded-3 bg-light">
    <sm-data-table [columnHeaders]="tableDisplayColumn" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate" [dataSource]="expenseListData"></sm-data-table>
  </div>
</mat-card> -->

<div class="expenjkad"  *ngIf="!loader && expenseListData.length > 0">
  <div class="row">
    <div class="col-sm-4" *ngFor="let item of expenseListData">
  <mat-card >
  <div class="package-card" >
    <div class="package-header">
      <div class="package-price">{{item.pprice}}</div>
      <button mat-icon-button [matMenuTriggerFor]="packageMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  
    <div class="package-title">{{item.label}}{{item.reason ? ', ' + item.reason : ''}}</div>
    <div class="package-date">{{item.expenseDatetime | date}}</div>
    <mat-menu #packageMenu="matMenu">
      <button mat-menu-item [disabled]="item.expenseType != 1 " (click)="deleteExpense(item)">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span>{{ 'expenses.op4_delete' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</mat-card>
</div>
</div>
</div>

<!-- <mat-paginator
*ngIf="!loader && expenseListData.length > 0"
  class="mt-4"
  [length]="datalength"
  [pageSize]="25"
  (page)="onPageChange($event)"
>
</mat-paginator>  -->



 <!-- <ng-container>

  <div class="merchant_detail_sec"  >
    <div class="mrt_offer">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#b0b0b0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
  
      <h3>
        Inventory items are coming
      </h3>
      <p>
        We are working hard day and night to bring this for you.
      </p>
    </div>
  </div>   
</ng-container> -->






<!-- placeholder html start -->

<div class="placeholder_started" *ngIf="!loader && expenseListData.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/expenses-1.png">
                 </div>
                 <mat-card-title>No expense data</mat-card-title>
                 <mat-card-content>No expenditure record added so far with this business. Start adding one here to manage and track expenses. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                  <button mat-button aria-label="option menu" [matMenuTriggerFor]="menu" color="accent">
                    <mat-icon class="material-icons-round try" [inline]="true" style="    position: relative;
                    top: -2px !important;
                    margin-right: 6px;">add</mat-icon>Record expenditure</button>
                    <mat-menu #menu="matMenu">
                      <button  mat-menu-item (click)="openPurchases()" >
                        <mat-icon class="material-icons-outlined">local_mall</mat-icon>
                        <span>{{ 'expenses.op1_item_purchase' | translate }}</span>
                      </button>
                      <button  mat-menu-item (click)="openEmloyees()" >
                        <mat-icon class="material-icons-outlined">payments</mat-icon>
                        <span>{{ 'expenses.op2_salary_credit' | translate }}</span>
                      </button>
                      <button  mat-menu-item (click)="onOtherExpenses()">
                        <mat-icon class="material-icons-outlined">receipt</mat-icon>
                        <span>{{ 'expenses.op3_other_business_expense' | translate }}</span>
                      </button>
                    </mat-menu>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>

          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to record expenses?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on how to record your business expenses. Get the guide to start with.

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary">
                     <mat-icon>help</mat-icon>
                    See help doc
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding an expenditure record or issue with getting the list, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div>  

  <!-- placeholder html end -->